import React,{useState,useEffect} from 'react'
import {Box,Heading } from 'grommet'
import { withRouter } from 'react-router-dom';
import AccountForm from '../../components/accountForm'
import { API,Auth } from 'aws-amplify';
import {APIRequest} from '../../components/utils/shared/requests'
import { NavigationSnackBar,ReturnAddress,LoadLayer } from '../../components/utils/shared/shared';

function LabEditCustomer (props) {
  const [customer, setCustomer] = useState();
  const [load, setLoad] = useState(true); 
  useEffect(() => {     
    APIRequest(`/customers/${props.match.params.customer_id}`).then(result => {setCustomer(result); setLoad(false)})
   },[]);
    const handleSubmit = () => {
        setLoad(true)
        const updatedLab = customer
        setCustomer(ReturnAddress(customer, 'customer', 'update'))
        Auth.currentSession().then(session => {
          API
          .put("LabShip", `/customers/${customer.id}`,
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{customer: updatedLab}})
          .then(shipment => {
            setLoad(false)
            props.history.push({pathname:'/customers/all', customerSucc: true, edit:false})
         })
        })
      }
    
  return (
   <Box flex="grow">
     {(load ? <LoadLayer load={load} label={'Loading Customer'} />: 
        <Box>
          <NavigationSnackBar title={`Edit Customer: ${customer.name}`} user={props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Customers', link: '/customers/all'}]}  />
          <Box alignSelf='center' elevation='medium' direction='column' margin='small' round width='xxlarge'>
            <Heading level="4" margin='small'>{customer.name}</Heading>
            <AccountForm user={props.user} label={"Update Customer"} account={customer} lab={customer.lab} customer={customer} load={load} handleSubmit={handleSubmit} setAccount={setCustomer} />
          </Box>
        </Box>
     )}
     
   </Box>
  )
}

export default withRouter(LabEditCustomer)
